// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1L7ZO","title":"Info_title__sJJDR","links":"Info_links__ZKQTF","link":"Info_link__2vjAL","logo":"Info_logo__5rmvw"};